import { Utils } from '@/app/infrastructures/misc'
import {
  LoginRequestInterface,
  ChangePasswordRequestInterface,
  ForgotPasswordRequestInterface,
  ForgotPasswordVerifyRequestInterface,
  ResetPasswordRequestInterface,
  RequestLibertaOTPInterface,
  ExchangeOTPRequestInterface,
  ProfileMfaOtpRequestInterface,
} from '@/data/payload/contracts/AuthRequest'

export class LoginApiRequest implements LoginRequestInterface {
  private role: string
  private email: string
  private password: string

  constructor(role: string, email: string, password: string) {
    this.role = role
    this.email = email
    this.password = password
  }

  public toPayload(): string {
    const data = {
      role: this.role,
      username: this.email,
      password: this.password,
    }

    return JSON.stringify({
      ...data,
    })
  }
}

export class ForgotPasswordRequest implements ForgotPasswordRequestInterface {
  email = "";
  token = "";
  otpType: "" | "PASSWORD_RESET" = ""

  constructor(fields?: Partial<ForgotPasswordRequest>) {
    Object.assign(this, fields);
  }

  public toPayload(): string {
    return JSON.stringify({
      email: this.email,
      otp_type: this.otpType
    })
  }
}

export class ForgotPasswordVerifyRequest
  implements ForgotPasswordVerifyRequestInterface {
  private token: string

  constructor(token: string) {
    this.token = token
  }

  public toPayload(): string {
    return JSON.stringify({
      token: this.token,
    })
  }
}

export class ResetPasswordRequest implements ResetPasswordRequestInterface {
  private token: string
  private password: string
  private passwordConfirmation: string

  constructor(token: string, password: string, passwordConfirmation: string) {
    this.token = token
    this.password = password
    this.passwordConfirmation = passwordConfirmation
  }

  public toPayload(): string {
    return JSON.stringify({
      token: this.token,
      password: this.password,
      password_confirm: this.passwordConfirmation,
    })
  }
}

export class ChangePasswordApiRequest
  implements ChangePasswordRequestInterface {
  private passwordCurrent: string
  private password: string
  private passwordConfirm: string
  private token: string

  constructor(
    passwordCurrent: string,
    password: string,
    passwordConfirm: string,
    token: string
  ) {
    this.passwordCurrent = passwordCurrent
    this.password = password
    this.passwordConfirm = passwordConfirm
    this.token = token
  }

  public toPayload(): string {
    const data = {
      password_current: this.passwordCurrent,
      password: this.password,
      password_confirm: this.passwordConfirm,
      token: this.token,
    }

    return JSON.stringify({
      ...data,
    })
  }
}

export class RequestLibertaOTP implements RequestLibertaOTPInterface {
  token = "";
  email = "";
  role = "";
  otpType = "";
  messagingType = "";
  captcha = "";
  challengeToken = "";

  constructor(fields?: Partial<RequestLibertaOTP>) {
    Object.assign(this, fields);
  }

  toPayload(): string {
    return JSON.stringify({
      email: this.email,
      role: this.role,
      otp_type: this.otpType,
      messaging_type: this.messagingType,
      captcha: this.captcha,
      challenge_token: this.challengeToken
    })
  }

}

export class ExchangeOTPRequest implements ExchangeOTPRequestInterface {
  otpId = 0;
  otp = "";
  challengeToken = "";

  constructor(fields?: Partial<ExchangeOTPRequest>) {
    Object.assign(this, fields);
  }

  toPayload(): string {
    return JSON.stringify({
      otp_id: this.otpId,
      otp: this.otp,
      challenge_token: this.challengeToken
    })
  }
}


export class ProfileMfaOtpRequest implements ProfileMfaOtpRequestInterface {
  captcha = ''

  constructor(fields?: Partial<ProfileMfaOtpRequest>) {
    Object.assign(this, fields)
  }

  toPayload(): string {
    return JSON.stringify({
      captcha: this.captcha,
    })
  }
}

